"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: {
      display: 'grid',
      width: '100%',
      placeItems: 'center',
      gridTemplateRows: '100%'
    },
    fiveColRoot: {
      gridTemplateColumns: 'repeat(2, 30px) 0.8fr repeat(2, 30px)'
    },
    sevenColRoot: {
      gridTemplateColumns: 'repeat(3, 30px) 0.8fr repeat(3, 30px)'
    },
    text: {
      color: 'white',
      fontSize: '1.2rem',
      whiteSpace: 'nowrap'
    },
    enabled: {
      fontSize: 30,
      color: 'white'
    },
    disabled: {
      fontSize: 30,
      color: 'grey'
    },
    doubleArrowLeft: {
      position: 'absolute',
      right: 18
    },
    doubleArrowRight: {
      position: 'absolute',
      left: 18
    },
    withSidebar: {
      color: 'black'
    },
    withSidebarText: {
      color: '#7b7b7b'
    },
    tooltip: {
      fontSize: '0.9rem !important'
    }
  };
};

var PageIncrement = function PageIncrement(props) {
  var classes = props.classes,
      page = props.page,
      pageCount = props.pageCount,
      setCurrentDocument = props.setCurrentDocument,
      setPage = props.setPage,
      prevDocId = props.prevDocId,
      nextDocId = props.nextDocId,
      withSidebar = props.withSidebar;
  var rootClass = (0, _classnames.default)(classes.root, setCurrentDocument ? classes.sevenColRoot : classes.fiveColRoot);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClass
  }, setCurrentDocument && /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: "Previous Document",
    enterDelay: 500,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    disabled: !prevDocId,
    onClick: function onClick() {
      return setCurrentDocument(prevDocId);
    },
    "data-test-id": "PageIncrement-prevDocButton"
  }, /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowLeft, {
    className: (0, _classnames.default)(classes[prevDocId ? 'enabled' : 'disabled'], _defineProperty({}, classes.withSidebar, withSidebar && prevDocId))
  }), /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowLeft, {
    className: (0, _classnames.default)(classes.doubleArrowLeft, classes[prevDocId ? 'enabled' : 'disabled'], _defineProperty({}, classes.withSidebar, withSidebar && prevDocId))
  })))), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: "Start of Document",
    enterDelay: 500,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    disabled: page <= 1,
    onClick: function onClick() {
      return setPage(null, 1);
    },
    "data-test-id": "PageIncrement-firstPageButton"
  }, /*#__PURE__*/_react.default.createElement(_icons.FirstPage, {
    className: (0, _classnames.default)(classes[page > 1 ? 'enabled' : 'disabled'], _defineProperty({}, classes.withSidebar, withSidebar && page > 1))
  })))), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: "Previous Page",
    enterDelay: 500,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    disabled: page <= 1,
    onClick: function onClick() {
      return setPage(-1);
    },
    "data-test-id": "PageIncrement-prevPageButton"
  }, /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowLeft, {
    className: (0, _classnames.default)(classes[page > 1 ? 'enabled' : 'disabled'], _defineProperty({}, classes.withSidebar, withSidebar && page > 1))
  })))), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: (0, _classnames.default)(classes.text, _defineProperty({}, classes.withSidebarText, withSidebar)),
    "data-test-id": "PageIncrement-positionInfo"
  }, "Page ", page, " of ", pageCount), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: "Next Page",
    enterDelay: 500,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    disabled: page >= pageCount,
    onClick: function onClick() {
      return setPage(1);
    },
    "data-test-id": "PageIncrement-nextPageButton"
  }, /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowRight, {
    className: (0, _classnames.default)(classes[page < pageCount ? 'enabled' : 'disabled'], _defineProperty({}, classes.withSidebar, withSidebar && page < pageCount))
  })))), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: "End of Document",
    enterDelay: 500,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    disabled: page >= pageCount,
    onClick: function onClick() {
      return setPage(null, pageCount);
    },
    "data-test-id": "PageIncrement-lastPageButton"
  }, /*#__PURE__*/_react.default.createElement(_icons.LastPage, {
    className: (0, _classnames.default)(classes[page < pageCount ? 'enabled' : 'disabled'], _defineProperty({}, classes.withSidebar, withSidebar && page < pageCount))
  })))), setCurrentDocument && /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: "Next Document",
    enterDelay: 500,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    disabled: !nextDocId,
    onClick: function onClick() {
      return setCurrentDocument(nextDocId);
    },
    "data-test-id": "PageIncrement-nextDocButton"
  }, /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowRight, {
    className: (0, _classnames.default)(classes[nextDocId ? 'enabled' : 'disabled'], _defineProperty({}, classes.withSidebar, withSidebar && nextDocId))
  }), /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowRight, {
    className: (0, _classnames.default)(classes.doubleArrowRight, classes[nextDocId ? 'enabled' : 'disabled'], _defineProperty({}, classes.withSidebar, withSidebar && nextDocId))
  })))));
};

var _default = (0, _styles.withStyles)(styles)(PageIncrement);

exports.default = _default;